export default "__VITE_ASSET__CtwUUUx4__"